// extracted by mini-css-extract-plugin
module.exports = {"container":"ListPlaceholderProject_container__1Sewc","textLine":"ListPlaceholderProject_textLine__2uK5R","imgArrow":"ListPlaceholderProject_imgArrow__15Gok"};